var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "menu icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.5 20.4785L6.76071 11.4849V29.8931C6.76071 30.0427 6.80879 30.1655 6.90496 30.2617C7.00112 30.3579 7.124 30.406 7.27358 30.406H22.7864V32.4999H7.27358C6.55725 32.4999 5.94369 32.2445 5.43291 31.7337C4.92214 31.223 4.66675 30.6094 4.66675 29.8931V10.1068C4.66675 9.3905 4.92214 8.77694 5.43291 8.26617C5.94369 7.75539 6.55725 7.5 7.27358 7.5H33.7265C34.4428 7.5 35.0564 7.75539 35.5672 8.26617C36.0779 8.77694 36.3333 9.3905 36.3333 10.1068V22.2863H34.2394V11.4849L20.5 20.4785ZM20.5 18.2884L33.9829 9.59396H7.01716L20.5 18.2884ZM32.1282 37.2445L30.6699 35.7863L33.8986 32.4999H25.3932V30.406H33.9146L30.6283 27.1196L32.1282 25.6613L37.9198 31.4529L32.1282 37.2445ZM6.76071 11.4849V31.6762V22.2863V22.5085V9.59396V11.4849Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentIcon);
export default __webpack_public_path__ + "static/media/sentIcon.9db30d9f5574ab2ebb4b2c68b1d755d6.svg";
export { ForwardRef as ReactComponent };